import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../utils/assets";
import Button from "./form/Button";

export const DashboardNoUpdates = () => {
  return (
    <div className="no-updates">
      <img
        className="no-updates__image"
        src={IMAGES.UPDATE_PROFILE_IMAGE}
        alt={
          "Illustration of two people sitting down while using a phone and a computer"
        }
      />
      <div className="no-updates__text">
        <h2 className="text-md text-md--variant">
          There is no updates in progress
        </h2>
        <p className="paragraph-md">
          Do you need to update any other personal details?
        </p>
      </div>
      <Link to="/dashboard-welcome">
        <Button variant="primary">Update now</Button>
      </Link>
    </div>
  );
};
